export default "__VITE_ASSET__Drux3hSl__"